/**
 * Created by Reda on 28.04.2025
 */

const UpgradeAvailableWindow = CleverappsWindow.extend({
    ctor: function (options) {
        options = options || {};

        this.trigger = options.trigger;
        this.onUpdate = options.onUpdate;
        this.onDismiss = options.onDismiss;

        switch (this.trigger) {
            case NewVersionChecker.TRIGGER_ALL_DONE:
                this.canClose = true;
                this.messages = "all_done";
                break;
            case NewVersionChecker.TRIGGER_OLD_BUILD:
                this.canClose = true;
                this.messages = "old_build";
                break;
            default:
                this.canClose = false;
                this.messages = "reload";
        }

        this._super();

        this.setLocalZOrder(Transition.ZORDER + 1);
    },

    onWindowLoaded: function () {
        this._super({
            name: "UpgradeAvailableWindow",
            title: Messages.get(`UpgradeAvailableWindow.${this.messages}.Title`),
            content: this.createContent(),
            closeButton: this.canClose
        });
    },

    createContent: function () {
        const styles = cleverapps.styles.UpgradeAvailableWindow;

        const illustration = new cc.Sprite(bundles.upgrade_available_window.urls.upgrade_available_illustration);

        const text = cleverapps.UI.generateOnlyText(Messages.get(`UpgradeAvailableWindow.${this.messages}.Text`), cleverapps.styles.FONTS.UPGRADE_AVAILABLE_WINDOW_TEXT);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        text.setVerticalAlignment(cc.VERTICAL_TEXT_ALIGNMENT_CENTER);
        text.setDimensions(illustration.width, 0);

        const buttons = [];

        if (this.canClose) {
            buttons.push(new cleverapps.UI.Button({
                type: cleverapps.styles.UI.Button.Images.button_red,
                width: styles.button.width,
                height: styles.button.height,
                text: Messages.get("UpgradeAvailableWindow.Later"),
                onClicked: () => {
                    this.close();
                }
            }));
        }

        buttons.push(new cleverapps.UI.Button({
            width: styles.button.width,
            height: styles.button.height,
            text: Messages.get(this.canClose ? "UpgradeAvailableWindow.Update" : "UpgradeAvailableWindow.Reload"),
            onClicked: () => {
                this.updated = true;
                this.onUpdate();

                if (this.canClose) {
                    this.close();
                }
            }
        }));

        return new cleverapps.Layout([illustration, text, new cleverapps.Layout(buttons, {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.margin
        })], {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });
    },

    onClose: function () {
        if (!this.updated && this.onDismiss) {
            this.onDismiss();
        }
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    UPGRADE_AVAILABLE_WINDOW_TEXT: {
        name: "nostroke",
        size: 40,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    }
});

cleverapps.styles.UpgradeAvailableWindow = {
    margin: 30,

    button: {
        width: 200,
        height: 90
    }
};
